// PERMISSION CHECK
// Returns true if the error is a permission-related error (401/403)
// These should not show toast notifications as they are expected when user lacks permissions
export const isPermissionError = (error) => {
  if (!error?.response) return false;
  const status = error.response.status;
  return status === 401 || status === 403;
};

// ERRORS
export const adminLoadErrorMsg = (msgInsert) =>
  `Les données "${msgInsert}" n'ont pas pu être chargées !`;
export const adminPostErrorMsg = (msgInsert) =>
  `Erreur lors de l'ajout ${msgInsert} !`;
export const adminPatchErrorMsg = (msgInsert) =>
  `Erreur de sauvegarde des modifications ${msgInsert} !`;
export const adminDeleteErrorMsg = (msgInsert) =>
  `Erreur lors de la suppression ${msgInsert} !`;

// SUCCESS
export const adminPostSuccessMsg = (msgInsert) =>
  `Ajout ${msgInsert} effectué !`;
export const adminPatchSuccessMsg = (msgInsert) =>
  `Modification ${msgInsert} effectuée !`;
export const adminDeleteSuccessMsg = (msgInsert) =>
  `Suppression ${msgInsert} effectuée !`;